import styled from '@emotion/styled';
import DialogActions from '@material-ui/core/DialogActions';
import theme from '../../themes/default';

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin: 0;
  width: 100%;
  padding: 0;
`;

export const Container = styled('div')`
  height: 40px;
  min-height: 32px;
  padding: ${theme.spacing.small} ${theme.spacing.xLarge} ${theme.spacing.small};
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: ${({ border }) =>
    border ? `1px solid ${theme.color.designSystem.blackOpacity12}` : 'none'};
  background-color: ${theme.color.white};
  display: flex;
  justify-content: center;
`;
